import { Injectable } from "@angular/core";
import { ApiClient } from "@info-click/api-client";
import { CacheService } from "@info-click/cache";
import { Socket } from "ngx-socket-io";
import { AiTranslate } from "./ai-translate";

@Injectable()
export class AiTranslateRepository {
  private uri = "ai-translations";

  constructor(
    private api: ApiClient,
    private cache: CacheService,
    private socket: Socket
  ) {
    this.socket.fromEvent(`model-saved.${this.uri}`).subscribe(() => {
      this.cache.forget(`${this.uri}.search.*`);
    });
  }

  search(query?: object) {
    return this.api.get(this.uri, query || {});
  }
  all() {
    return this.api.get(this.uri, { _all: true });
  }
  find(id: string) {
    return this.api.get(this.uri + "/" + id);
  }
  translate(entity_id: string, entity_type: string, fields: string[]) {
    return this.api.post(this.uri + "/translate-fields", {
      entity_id: entity_id,
      entity_type: entity_type,
      fields: fields,
    });
  }
  save(item: AiTranslate) {
    return item.id
      ? this.api.put(this.uri + "/" + item.id, item)
      : this.api.post(this.uri, item);
  }

  delete(id: string) {
    return this.api.delete(this.uri + "/" + id);
  }
}
